// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://tdrdiflbdlftfwudjeim.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRkcmRpZmxiZGxmdGZ3dWRqZWltIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDk4MzQ5MzEsImV4cCI6MjAyNTQxMDkzMX0.eJS9r_QHbfDFodV6Y5_AgB40vQ-Bbqx3oodyURjFKuY';

const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
